import React from 'react';
import { stockPhoto } from '../../assets/stock/index.ts';

const AnimatedBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Main Ocean Background */}
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `url(${stockPhoto('1559827260-dc66d52bef19', 1920, 1080)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          animation: 'gentle-waves 20s ease-in-out infinite'
        }}
      />

      {/* Moving Clouds Layer */}
      <div
        className="absolute inset-0 opacity-15"
        style={{
          backgroundImage: `url(${stockPhoto('1506905925346-21bda4d32df4', 1920, 1080)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          animation: 'moving-clouds 25s ease-in-out infinite'
        }}
      />

      {/* Subtle Overlay for Text Readability */}
      <div
        className="absolute inset-0 bg-white opacity-5"
      />
    </div>
  );
};

export default AnimatedBackground;
